// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\EnumType.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumItemMD } from '../../../../../../libs/com/MetaPattern/MDA/MD/EnumItemMD';

/**
 * 租户类型枚举 枚举类
 * 租户类型枚举
 */
export enum EnumTenancyType {
  /** 机构 : 机构 */
  Organization = 1,
  /** 个人 : 个人 */
  Person = 2
}

/**
 * 租户类型枚举 枚举元数据类
 * 获取枚举的元数据信息：名称、显示名称、描述、值
 */
export class EnumTenancyTypeMD {
  private static items = [
    new EnumItemMD('Organization', 1, '机构', '机构'),
    new EnumItemMD('Person', 2, '个人', '个人')
  ];

  static getItem(enumItem: EnumTenancyType) {
    return this.items.find(item => item.name === EnumTenancyType[enumItem]);
  }

  static getItemByName(enumItemName: string) {
    return this.items.find(item => item.name === enumItemName);
  }

  static getItemByValue(enumItemValue: number) {
    return this.items.find(item => item.value === enumItemValue);
  }

  static getItems() {
    return this.items;
  }
}
